module.exports = __webpack_public_path__ + "img/undraw-security-on.6e693f01.svg";